import React from 'react';
import { pathgen } from 'object-path-generator';
export function computeMenuOrigins(vAlign, hAlign, gap) {
    return {
        anchorOrigin: {
            vertical: vAlign === 'top' ? -gap : 'bottom',
            horizontal: hAlign
        },
        transformOrigin: {
            vertical: vAlign === 'bottom' ? -gap : 'bottom',
            horizontal: hAlign
        }
    };
}
export const DropdownMenuItemTestIds = pathgen('DropdownMenuItemTestIds');
